import React from "react";
import CircularProgress from '@mui/material/CircularProgress';

const PrimaryProgress = () => {
    return(
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '100%'}}>
            <CircularProgress />
        </div>
    );
}

export default PrimaryProgress;